import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { User } from "../../../@types/user";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const findAssignedUsers = createAsyncThunk(
  "templateDetail/findAssignedUsers",
  async (id: string, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const { data: formSubmittedResponse } = await axiosInstance.get(`${api.baseURL}formsubmitted`, {
        params: {
          where: {
            form: id,
          },
        },
      });

      const { data: userRoleResponse } = await axiosInstance.get(`${api.baseURL}userrole`, {
        params: {
          where: {
            user: formSubmittedResponse.map(({ user }: { user: User }) => user?.id),
          },
        },
      });

      return userRoleResponse;
    } catch (error) {}
  }
);
